import { AuthenticatedLayout } from "../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { TD1FormSetup } from "../../../components/ClientTD1FormSetup/TD1FormSetup";
import { useParams } from "react-router-dom";


export const TD1FormPage = () => {
  const { td1FormName } = useParams();

  return (
    <AuthenticatedLayout
      pageTitle={`${
        // td1FormName === "federal" ? "Federal" :
        td1FormName === "alberta" ? "Alberta" :
        td1FormName === "british_columbia" ? "British Columbia" :
          td1FormName === "manitoba" ? "Manitoba" :
            td1FormName === "new_brunswick" ? "New Brunswick" :
              td1FormName === "newfoundland_and_labrador" ? "Newfoundland and Labrador" :
                td1FormName === "northwest_territories" ? "Northwest Territories" :
                  td1FormName === "nova_scotia" ? "Nova Scotia" :
                    td1FormName === "nunavut" ? "Nunavut" :
                      td1FormName === "ontario" ? "Ontario" :
                        td1FormName === "prince_edward_island" ? "Prince Edward Island" :
                          td1FormName === "quebec" ? "Quebec" :
                            td1FormName === "saskatchewan" ? "Saskatchewan" :
                              td1FormName === "yukon" ? "Yukon" :
                                td1FormName
        }`}

      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<TD1FormSetup testId="td1-form-setup" />}
    />
  );
};
